import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
// import { TopBanner } from "../../common/TopBanner";
import { detail_one } from "./detail_one";
import { gallery } from "./gallery";
import { RoomList } from "./RoomList";
import { FloorPlan } from "./FloorPlan";
import { history_list } from "../../common/history_list";
import { campaign } from "./campaign";
import { recommended_points } from "./recommended_points";
import { confirmation_matters } from "./confirmation_matters";
import { web_look } from "./web_look";
import masterData from "../../lib/masterData";
import { TYPE_PC, TYPE_SP } from "../../common/defines";
import api from "../../lib/api";
import criteo from "../../lib/criteo";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { notfound } from "../static/notfound";
import { banner_static } from "../../common/banner_static";
import { banner_static2 } from "../../common/banner_static2";
import { isBetsukanriInHokkaido } from "../../lib/isBetsukanriInHokkaido"

export class Detail extends React.Component {
  state = { activeImageIndex: 0 };
  constructor(props) {
    super(props);
    this.prepare(props);
    this.recordHistory(props);
  }
  componentWillReceiveProps(nextProps) {
    this.recordHistory(nextProps);
    this.prepare(nextProps);
  }
  recordHistory(props) {
    const currentAssetId = props.match.params.asset;
    let assetHistory = JSON.parse(localStorage.getItem('assetHistory') || null) || [];
    assetHistory = assetHistory.filter(assetId => assetId !== currentAssetId)
    assetHistory.unshift(currentAssetId);
    assetHistory.slice(0, 256);
    localStorage.setItem('assetHistory', JSON.stringify(assetHistory));
  }
  async prepare(props) {
    const params = props.match.params;
    const asset = await api.detail(params.asset);
    if (!asset) {
      console.log("detail prepare", props);
      this.setState({ notFound: true });
    } else {
      asset.isAssetReceived = true;
      this.setState({ asset });
    }
  }
  onSelectActiveImage = activeImageIndex => {
    this.setState({ activeImageIndex });
  };
  onSelectNextActiveImage = (isNext) => {
    const index = isNext ? this.state.activeImageIndex + 1 : this.state.activeImageIndex - 1;
    if (index === this.state.asset.images.length) {
        this.setState({ activeImageIndex: 0 });
    } else if (index < 0) {
        this.setState({ activeImageIndex: (this.state.asset.images.length - 1) });
    } else {
        this.setState({ activeImageIndex: index });
    }
  };

  toggleContent = detailVisible => {
    this.setState({ detailVisible: !detailVisible });
  };
  /* eslint-disable complexity */
  render() {
    const params = this.props.match.params;
    // this.state.asset→ Detail API 経由のasset
    //  masterData.asset.byId[params.asset]→List API経由のasset（ダイジェストのみ）
    const digestAsset = params.asset && masterData.asset ? masterData.asset.byId[params.asset] : null;
    const asset = (digestAsset || this.state.asset) && Object.assign({}, digestAsset, this.state.asset);
    criteo.sendEvent({
      event: "viewItem",
      item: params.asset,
    });

    const pref = masterData.pref.byId[asset && asset.pref] || masterData.pref.bySlug[params.pref];
    const paramCity = pref && params.city ? masterData.city.byPrefAndSlug[pref.prefId][params.city] : null;
    const city = pref && masterData.city.byPrefAndSlug[pref.prefId][asset && asset.city] || paramCity || {};

    let baseCity = null;
    if (city && city.districtSlug) {
      baseCity = masterData.city.byPrefAndSlug[pref.prefId][city.baseSlug];
    }
    const { type } = this.props;
    console.log(asset, this.state.notFound);
    if (this.state.notFound) {
      return notfound(type);
    } else if (!asset) {
      return <div className="loading">loading</div>
    }

    return (
      <div className="container">
        {breadcrumbs(type, [
          {
            href: `/${pref && pref.slug}/list/`,
            text: pref && pref.name,
          },
          baseCity && {
            href: `/${pref && pref.slug}/${baseCity.slug}/`,
            text: baseCity.name,
          },
          baseCity && {
            href: `/${pref && pref.slug}/${baseCity.slug}/${city.districtSlug}/`,
            text: city.districtName,
          },
          !baseCity && {
            href: `/${pref && pref.slug}/${city.slug}/`,
            text: city.name,
          },
          {
            text: asset.name,
          },
        ].filter(item => item))}

        <div className="content content_roomlist">
          {detail_one(type, asset, this.state.activeImageIndex, this.toggleContent, this.state.detailVisible, this.onSelectNextActiveImage)}
          <div className="pc">
            {gallery(
              type,
              asset,
              this.state.activeImageIndex,
              this.onSelectActiveImage,
              this.onSelectNextActiveImage
            )}
          </div>
          {(type === TYPE_PC && !isBetsukanriInHokkaido(asset)) && banner_static(type)}
          {(type === TYPE_PC && !isBetsukanriInHokkaido(asset) && asset.premium === 1) && <br/>}
          {(type === TYPE_PC && !isBetsukanriInHokkaido(asset) && asset.premium === 1) && banner_static2(type)}
         <RoomList {...this.props} asset={asset} />
          {(() => {
            return asset.floorplan && (<FloorPlan {...this.props} asset={asset} />)
          })()}
          {type === TYPE_SP && asset.rooms && asset.rooms.every(room => room.vacant === masterData.vacant.UNAVAILABLE)
              ? <div/> : campaign({ type, asset })}
          <div className="container">
            {type === TYPE_SP && asset.rooms && asset.rooms.every(room => room.vacant === masterData.vacant.UNAVAILABLE)
              ? <div/> : recommended_points(type, asset.comment)}
          </div>
          <div className="container">
            {type === TYPE_SP && asset.rooms && asset.rooms.every(room => room.vacant === masterData.vacant.UNAVAILABLE)
              ? <div/> : confirmation_matters(type, asset)}
          </div>
          <div className="container line">
            <MasterDataReady delay={300} render={() => history_list(type, true, asset, this.props.history)}/>
          </div>
          <div className="container line">
            <MasterDataReady delay={300} render={() => history_list(type, false, asset, this.props.history)}/>
          </div>
          {web_look(type)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/detail/Detail.jsx